import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as resources from "../../../../constants/resources";
import * as navigationActions from "../../../../actions/navigationActions";
import * as myOrdersTabActions from "../../../../actions/myOrdersTabActions";
import * as actions from "../../../../actions/mainTabActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgOrder from "../../../../resources/img/svgicons/order2.svg";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Table from "../../../global/generic/Table";
import Modal from "../../../global/generic/Modal";

class SendOrderModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receiver: this.props.orderServer,
            customNote: this.props.dispenseNote !== null ? this.props.dispenseNote : "",
            sendOrderButtonDisabled: false
        };
    }

    findCompatibleServer = (uuid) => {
        for (let server of this.props.compatibleServerList) {
            if (server.uuid === uuid) {
                return server;
            }
        }

        return null;
    };

    saveDispenseNote = () => {
        this.props.dispatchSaveDispenseNote(this.props.tabId, this.state.customNote.trim());
        this.setState({
            customNote: this.state.customNote.trim()
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseSendOrderModalAction();
    };

    handleReceiverClick = (event) => {
        let receiver = this.findCompatibleServer(event.target.dataset.uuid);

        if (receiver !== null) {
            this.setState({
                receiver: receiver
            });
        }
    };

    handleSendOrderClick = () => {
        if (this.state.receiver !== null && !this.state.sendOrderButtonDisabled) {
            this.props.dispatchSendOrderAction(this.props.tabId, {
                productId: this.props.product === null ? null : this.props.product.id,
                fandeckId: this.props.fandeck === null ? null : this.props.fandeck.id,
                colorId: this.props.color === null ? null : this.props.color.id,
                colorLocal: this.props.color === null ? false : this.props.color.local,
                formulaId: this.props.formula === null ? null : this.props.formula.id,
                baseId: this.props.base === null ? null : this.props.base.id,
                customerId: this.props.customer === null ? null : this.props.customer.id,
                formulaColorants: this.props.formula === null ? null : this.props.formula.getRealColorantAmounts(),
                scaling: this.props.formula === null ? null : this.props.formula.scaling,
                numberOfPackages: this.props.numberOfPackages,
                packageId: this.props.package === null ? null : this.props.package.id,
                customPackage: this.props.package === null ? null : this.props.package.package.isCustom(),
                customPackageSize:
                    this.props.package === null
                        ? null
                        : this.props.package.package.isCustom()
                          ? this.props.package.package.nominalAmount
                          : null,
                customPackageUnit:
                    this.props.package === null
                        ? null
                        : this.props.package.package.isCustom()
                          ? this.props.package.package.unit
                          : null,
                databaseName: this.props.activeDatabase === null ? null : this.props.activeDatabase.name,
                receiverUuid: this.state.receiver.uuid,
                customNote: this.state.customNote,
                orderRecordType: this.props.formula === null ? null : this.props.formula.getStatsType(),
                moreInfoInternal: this.props.moreInfoInternal
            });
            this.setState({
                sendOrderButtonDisabled: true
            });
        }
    };

    handleCustomNoteInputChange = (event) => {
        if (validationHelper.isNoteValid(event.target.value)) {
            this.setState({
                customNote: event.target.value
            });
        }
    };

    getColorantsByUnit = () => {
        if (this.props.formula === null) {
            return [];
        }

        return this.props.formula.getRealColorantListByUnit(this.props.formulaUnits);
    };

    getFormulaDetail = () => {
        return this.getColorantsByUnit().map((colorant) => {
            return (
                <React.Fragment key={colorant.name}>
                    <div className="col-4">{colorant.name}</div>
                    <div className="col-8">{colorant.formatAmount() + " " + colorant.formatAmountType()}</div>
                </React.Fragment>
            );
        });
    };

    getFormulaDetailSection = () => {
        if (this.props.loggedUser.canNotRead(resources.COMPONENT_COLORANT_PANEL)) {
            return "";
        }

        return (
            <React.Fragment>
                <div className="col-4 color-primary">{translate("general.formula")}</div>
                <div className="col-8 flex flex-wrap">{this.getFormulaDetail()}</div>
            </React.Fragment>
        );
    };

    getActiveServerClass = (server) => {
        if (server.uuid === this.state.receiver.uuid) {
            return "active";
        }

        return "";
    };

    getServerList = () => {
        return this.props.compatibleServerList.map((compatibleServer) => {
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(compatibleServer.name, "", undefined, {
                        "data-uuid": compatibleServer.uuid
                    }),
                    modelHelper.buildTableCell(compatibleServer.ip, "", undefined, {
                        "data-uuid": compatibleServer.uuid
                    }),
                    modelHelper.buildTableCell(compatibleServer.note, "", undefined, {
                        "data-uuid": compatibleServer.uuid
                    })
                ],
                "cursor-pointer " + this.getActiveServerClass(compatibleServer),
                compatibleServer.uuid,
                {
                    "data-uuid": compatibleServer.uuid,
                    onClick: this.handleReceiverClick
                }
            );
        });
    };

    getServerDetail = () => {
        if (this.props.compatibleServerList.length === 0) {
            return <div className="color-warning">{translate("sendOrderModal.noCompatibleServers")}</div>;
        }

        if (this.props.compatibleServerList.length === 1) {
            return translate("sendOrderModal.sendOrderTo", {serverName: this.props.orderServer.name});
        }

        return (
            <Table
                tableHeader={modelHelper.buildTableRow([
                    modelHelper.buildTableCell(translate("general.nameTitle")),
                    modelHelper.buildTableCell(translate("general.ip")),
                    modelHelper.buildTableCell(translate("general.note"))
                ])}
                tableRows={this.getServerList()}
                tableColumns={[
                    modelHelper.buildTableColumn("col-4"),
                    modelHelper.buildTableColumn("col-4"),
                    modelHelper.buildTableColumn("col-4")
                ]}
            />
        );
    };

    getOtherInfo = () => {
        if (this.props.redlikeLightSoftware) {
            return null;
        }

        return (
            <div className="flex flex-wrap">
                <div className="col-12 color-primary font-size-2rem">{translate("sendOrderModal.orderOverview")}</div>
                <div className="col-4 color-primary">{translate("general.customer")}</div>
                <div className="col-8">{this.props.customer?.name ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.product")}</div>
                <div className="col-8">{this.props.product?.displayName ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.base")}</div>
                <div className="col-8">{this.props.base?.displayName ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.fandeck")}</div>
                <div className="col-8">{this.props.fandeck?.displayName ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.color")}</div>
                <div className="col-8">{this.props.formula?.color?.displayName ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.canSize")}</div>
                <div className="col-8">{this.props.package?.package?.displayName ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.quantity")}</div>
                <div className="col-8">{this.props.numberOfPackages ?? ""}</div>
                <div className="col-4 color-primary">{translate("general.colorPreview")}</div>
                <div
                    className="border-black border-radius-5 col-8"
                    style={{
                        backgroundColor: this.props.formula.color.rgb
                    }}
                />
                {this.getFormulaDetailSection()}
                <div className="col-4 color-primary">{translate("sendOrderModal.customNote")}</div>
                <div className="col-8">
                    <textarea
                        className="slim-scroll col-12"
                        value={this.state.customNote}
                        onChange={this.handleCustomNoteInputChange}
                        onBlur={this.saveDispenseNote}
                        style={{
                            height: "75px",
                            resize: "none"
                        }}
                    />
                </div>
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12">
                    <div className="col-12 color-primary font-size-2rem">
                        {translate("sendOrderModal.targetMachine")}
                    </div>
                    {this.getServerDetail()}
                </div>
                {this.getOtherInfo()}
            </React.Fragment>,
            "flex-column flex-gap-10px slim-scroll"
        );
    };

    getModalSendButton = () => {
        if (this.props.compatibleServerList.length === 0 || this.state.receiver === null) {
            return "";
        }

        if (this.state.sendOrderButtonDisabled) {
            return <Button svgBefore={imgOrder} label={translate("mainTab.order")} disabled />;
        }

        return <Button svgBefore={imgOrder} label={translate("mainTab.order")} onClick={this.handleSendOrderClick} />;
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getModalSendButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("sendOrderModal.sendOrder"))}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "50%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            loggedUser: store.login.loggedUser,
            orderServer: store.server.orderServer,
            compatibleServerList: store.server.compatibleServerList,
            activeDatabase: store.server.activeDatabase,
            redlikeLightSoftware: store.module.redlikeLightSoftware,
            product: null,
            fandeck: null,
            color: null,
            formula: null,
            base: null,
            package: null,
            numberOfPackages: 1,
            customer: null,
            formulaUnits: store.settings.formulaUnits,
            dispenseNote: null,
            moreInfoInternal: null
        };
    }

    return {
        loggedUser: store.login.loggedUser,
        orderServer: store.server.orderServer,
        compatibleServerList: store.server.compatibleServerList,
        activeDatabase: store.server.activeDatabase,
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        product: store.formula[ownProps.tabId].product,
        fandeck: store.formula[ownProps.tabId].fandeck,
        color: store.formula[ownProps.tabId].color,
        formula: store.formula[ownProps.tabId].formula,
        base: store.formula[ownProps.tabId].base,
        package: store.formula[ownProps.tabId].package,
        numberOfPackages: store.formula[ownProps.tabId].numCanTotal,
        customer: store.formula[ownProps.tabId].customer,
        formulaUnits: store.settings.formulaUnits,
        dispenseNote: store.formula[ownProps.tabId].dispenseNote,
        moreInfoInternal: store.formula[ownProps.tabId].moreInfoInternal
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseSendOrderModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CREATE_ORDER_MODAL));
        },
        dispatchSendOrderAction: (tabId, orderCrate) => {
            dispatch(myOrdersTabActions.sendOrder(tabId, orderCrate));
        },
        dispatchSaveDispenseNote: (tabId, note) => {
            dispatch(actions.saveDispenseNote(tabId, note));
        }
    };
};

export default SendOrderModal = connect(mapStoreToProps, mapDispatchToProps)(SendOrderModal);
